import { Backdrop, Chip, Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material'
import React, { memo, useState } from 'react'
import { useStyle } from '../style'
import _ from 'lodash'
import { Print, Visibility } from '@mui/icons-material'
import axios from 'axios'
import moment from 'moment'
import { useDispatch } from 'react-redux'
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers'
import GenerateQR from './generateQR'

const PurchasedData = ({data,flag, setFlag}) => {
  const classes = useStyle()
  const dispatch = useDispatch()
  const [active, setActive] = useState(null)
  const [qrData, setQRData] = useState([])
  const [open,setOpen] = useState(false)

  function getSelectedRow(e){
    setActive(e)
    } 

const currentYear = moment().year();
let financialYear;
if (moment().month() < 3) {
financialYear = currentYear - 1
} else {
  financialYear = currentYear
 }
    let fYear = financialYear.toString().slice(2)
    
function generateQRCode(e){
  console.log(e)

  const url2 = `/v1/barcode/against/purcahse/1/${e.prodid}/${e.docno}/${e.purchase_details_id}`
  const qrData={
    financial_year: fYear,
    supplier_code: e.short_name,
    prod_id: e.prodid,
    mrp: e.mrp,
    qty: e.qty,
    purchase_no: e.docno,
    company_id: 1,
    purchase_details_id: e.purchase_details_id
  }
  console.log(qrData,"qrcode")
  if(e.is_barcode_generated_list===0){
    axios.post('/v1/barcode/generate',qrData)
  .then(res=>{
    console.log(res)
    const url = `/v1/barcode/against/purcahse/1/${e.prodid}/${e.docno}/${e.purchase_details_id}`
    setFlag(!flag)
    getQRCode(url)
  })
  .catch(err=>{
    dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
  })
  }
  else{
  getQRCode(url2)
  setFlag(!flag)
  }
}
function getQRCode(url){
axios.get(url)
.then(res=>{
  console.log(res.data)
  setQRData(res.data)
  setOpen(true)
})
.catch(err=>{
  dispatch(setSnackbar(true, 'error', err.response.data.message))
  dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
})
}
  return (
   <Grid className='w-full h-full'>
    <TableContainer className={classes.tblRoot}>
      <Table stickyHeader className={classes.table}>
        <TableHead className={classes.tblHeader} sx={{position: "sticky",top: 0,}}>
          <TableRow className={classes.tablrow}>
            <TableCell>Sno</TableCell>
            <TableCell>Code</TableCell>
            <TableCell>Item Short Name</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Mrp</TableCell>
            <TableCell>GST%</TableCell>
            <TableCell>Qty</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
            {data.length > 0 ? _.map(data,(val, idx) => (
               <TableRow className={classes.tablrow} key={idx} onClick={() => getSelectedRow(idx)}>
               <TableCell  padding="checkbox" className={classes.tblContentCell}>{idx + 1}</TableCell>
               <TableCell>{val.pro_code}</TableCell>
               <TableCell variant="body" className={classes.tblContentCell}>{val.item_short_name}</TableCell>
               <TableCell variant="body" className={classes.tblContentCell}>{val.pro_name}</TableCell>
               <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}>{val.mrp}</TableCell>
               <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>{val.gst_per}</TableCell>              
               <TableCell>{val.qty}</TableCell>
               <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>{val.is_barcode_generated_list===0 ? <Chip size='small' label='GENERATE'/> : <Chip color='success' size='small' label='GENERATED'/>}</TableCell>
               <TableCell className={classes.tblContentCell} sx={{width:100}}>
                {val.is_barcode_generated_list===1 ? <IconButton onClick={()=>generateQRCode(val)}><Visibility/></IconButton> : <IconButton onClick={()=>generateQRCode(val)}><Print/></IconButton>}
               </TableCell>
             </TableRow>
            )) :
            <TableRow className={classes.tablrow}>
            <TableCell  padding="checkbox" className={classes.tblContentCell} sx={{borderLeft:'0.5px solid  #ccc'}}>{data.length + 1}</TableCell>
            <TableCell  padding="checkbox" sx={{ width: 120 }} className={classes.tblContentCell}></TableCell>
            <TableCell variant="body" className={classes.tblContentCell}></TableCell>
            <TableCell variant="body" className={classes.tblContentCell}></TableCell>
            <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}></TableCell>
            <TableCell  padding="checkbox" sx={{ width: 120 }}  className={classes.tblContentCell}></TableCell>
            <TableCell  padding="checkbox" sx={{ width: 120 }}  className={classes.tblContentCell}></TableCell>
            <TableCell  padding="checkbox" sx={{ width: 120 }}  className={classes.tblContentCell}></TableCell>
            <TableCell className={classes.tblContentCell} sx={{width:100}}><IconButton><Print/></IconButton></TableCell>
          </TableRow>
          }  
          </TableBody>
      </Table>
    </TableContainer>
    <Backdrop open={open} sx={{zIndex:1300}}>
      <GenerateQR data={qrData} close={setOpen}/>
    </Backdrop>
   </Grid>
  )
}

export default memo(PurchasedData)